var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:`bg-white
      border
      rounded
      p-2
      my-3
      text-center text-${_vm.variant}`},[_c('strong',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('ul',{staticClass:"list-unstyled mt-3 m-0 px-0 text-justify text-break"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"mb-2 fs_12"},[_c('i',{class:`${_vm.listIcon} mr-1`}),_c('span',{domProps:{"textContent":_vm._s(item)}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }